/**
 * Hr api spec
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReadUserDto } from './readUserDto';


export interface ReadStatusConfigDto { 
    /**
     * The unique identifier
     */
    id: string;
    /**
     * The code of the status config
     */
    code: string;
    /**
     * The kind of status config
     */
    kind: ReadStatusConfigDto.KindEnum;
    /**
     * Indicates if this is an entry status
     */
    isEntry: boolean;
    /**
     * Indicates if this is the last status
     */
    isLast: boolean;
    /**
     * The creation date of the status config
     */
    createdAt: string;
    /**
     * The last update date of the status config
     */
    updatedAt: string;
    /**
     * The user who created the status config
     */
    createdBy: ReadUserDto;
}
export namespace ReadStatusConfigDto {
    export const KindEnum = {
        Progress: 'progress',
        Blocked: 'blocked'
    } as const;
    export type KindEnum = typeof KindEnum[keyof typeof KindEnum];
}


